/**
 * Routes publiques (sans guard) : source unique partagée par le router
 * (`routes.tsx`) et le store d'auth. Purger la session ne redirige vers /login
 * que depuis une route protégée : une page à token (lien magique,
 * désinscription, découverte, annulation de suppression) reste affichée.
 */
export const PUBLIC_PATHS = {
  signup: '/signup',
  login: '/login',
  verifyEmail: '/verify-email',
  magicLogin: '/app/auth/magic',
  unsubscribe: '/app/unsubscribe',
  discovery: '/app/decouverte',
  prospectUnsubscribe: '/app/prospect/unsubscribe',
  deletionCancel: '/app/account/deletion/cancel',
} as const

export function isPublicPath(pathname: string): boolean {
  return (Object.values(PUBLIC_PATHS) as string[]).includes(pathname.replace(/(.)\/+$/, '$1'))
}
